import { Directive, forwardRef, Attribute, ElementRef, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';

@Directive({
  selector: '[appValidateAge]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => AgeValidator), multi: true }
  ]
})
export class AgeValidator implements Validator {

  constructor() { }

  @Input()
  minAge: number;

  @Input()
  maxAge: number;

  validate(control: AbstractControl): { [key: string]: any } {
    const value = control.value;

    let age: number = null;

    if (moment.isMoment(value)) {
      const mom = value as moment.Moment;
      age = environment.globalSettings.getAgeFromDate(mom.toDate());
    } else {
      age = this._getAgeFromString(value);
    }

    if (age == null) {
      return { ageValid: false };
    }

    if (this.minAge > 0 && age < this.minAge) {
      return { minAgeValid: false };
    }

    if (this.maxAge > 0 && age > this.maxAge) {
      return { maxAgeValid: false };
    }

    return null;
  }

  private _getAgeFromString(dateString: string): number {
    if (!dateString) {
      return null;
    }
    const birthDate = new Date(dateString);
    return environment.globalSettings.getAgeFromDate(birthDate);
  }
}
